import React, { useState, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  TextField,
  Button,
  Typography,
  Container,
  Alert,
  Collapse,
  IconButton,
  InputAdornment,
  CircularProgress,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Helmet } from 'react-helmet-async';
import authService from '../../services/authService';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');
  const [showAlert, setShowAlert] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setShowAlert(false);

    try {
      const data = await authService.loginAdmin(email, password);
      login(data.token);
      // Utiliser window.location pour forcer un refresh complet
      // afin que le state soit correctement initialisé
      window.location.href = '/admin';
    } catch (error) {
      console.error('Erreur lors de la connexion:', error);

      if (error.message.includes('non trouvé') || error.message.includes('not found')) {
        setErrorMessage('Administrateur non trouvé.');
      } else if (error.message.includes('incorrect') || error.message.includes('Invalid')) {
        setErrorMessage('Mot de passe incorrect.');
      } else {
        setErrorMessage(error.message || 'Erreur de connexion.');
      }
      setShowAlert(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Administration - Yoco</title>
      </Helmet>

      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#FFFFFF',
        }}
      >
        <Container maxWidth="xs">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              p: 4,
              borderRadius: 2,
              bgcolor: 'white',
            }}
          >
            {/* Logo */}
            <Box
              component="img"
              src="/static/icon.svg"
              alt="Yoco"
              sx={{ height: 50, mb: 2 }}
            />
            <Collapse in={showAlert} sx={{ width: '100%' }}>
              <Alert
                severity="error"
                onClose={() => setShowAlert(false)}
                sx={{ mb: 2 }}
              >
                {errorMessage}
              </Alert>
            </Collapse>

            <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%' }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                type="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isLoading}
                size="small"
              />

              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Mot de passe"
                type={showPassword ? 'text' : 'password'}
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isLoading}
                size="small"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(prev => !prev)}
                        edge="end"
                        size="small"
                      >
                        {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, py: 1.5 }}
                disabled={isLoading}
              >
                {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Connexion'}
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default AdminLogin;
